import testPhoneVue from './testPhone.vue'
export default {
	install(Vue, options){
		let testPhone = Vue.extend(testPhoneVue);
		let $testPhone = new testPhone(options);
		document.body.appendChild($testPhone.$mount().$el);
		Vue.prototype.$testPhone = (model => {
			model.value=true
			$testPhone.option=model
		})
	}
  }
